import React, {
  Breadcrumbs as MuiBreadcrumbs,
  BreadcrumbsProps as MuiBreadcrumbsProps,
} from '@mui/material';
import HsContainer from 'shared/lib/components/containers/hsContainer';
import { useCurrentBreakpoint } from 'shared/hooks/useCurrentBreakpoint';
import { useTypographyFonts } from 'shared/hooks/useGetTypographyFonts';

export default function Breadcrumbs({ ...other }: {} & MuiBreadcrumbsProps) {
  const currentBp = useCurrentBreakpoint();
  const { getFontSize } = useTypographyFonts({ currentBp });

  return (
    <HsContainer>
      <MuiBreadcrumbs
        sx={{
          '& .MuiBreadcrumbs-li': {
            'color': 'text.primary',
            'cursor': 'pointer',
            'alignSelf': 'stretch',

            '&:last-child': {
              color: 'text.secondary',
            },
          },
          '& .MuiBreadcrumbs-separator, & .MuiBreadcrumbs-li': {
            mobile: { fontSize: getFontSize('f10') },
            laptop: { fontSize: getFontSize('f12') },
            mx: 1.5,
          },
          ...other.sx,
        }}
        {...other}
      ></MuiBreadcrumbs>
    </HsContainer>
  );
}
